import React from 'react';
import LegalPage from './LegalPage';

const TERMS = `# Resi Terms of Use

**Effective date:** October 2026

Resi is an internal tool of The Community Real Estate LLC dba RESIDENCE | eXp Realty, Estero, Florida, for use by authorized RESIDENCE team members only.

## Use
- Use Resi only for RESIDENCE business and keep your sign-in private.
- Honor every client's communication preferences, including STOP and unsubscribe requests.
- Do not upload content you don't have the right to use.

## Privacy
How we handle information is described in our [Privacy Policy](https://resisystem.com/privacy).

## Changes
These terms are a placeholder and will be expanded. Questions: privacy@resisystem.com.`;

export default function TermsPage() { return <LegalPage markdown={TERMS} />; }
